module.exports = __webpack_public_path__ + "img/Frame.e49976f3.png";